import { types } from 'mobx-state-tree'
import { eases } from 'eplayer-core'

export default types.model('VideoKeyframe', {
  Type: types.literal('Keyframe'),
  kind: types.literal('video'),
  objectId: types.identifier,
  frame: types.integer,
  fn: types.enumeration(eases.easings),
  src: types.string,
  label: types.string,
  value: types.number,
})

